//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return{
      analyList:{},
      list1: [
        {
          value: '2分钟',
          name: '2分钟',
        },
        {
          value: '10分钟',
          name: '10分钟',
        },
        {
          value: '30分钟',
          name: '30分钟',
        },
        {
          value: '1小时',
          name: '1小时',
        },
        {
          value: '2小时',
          name: '2小时',
        }
      ],
    }
  },
  mounted() {
    this.finaceList()
  },
  methods:{
    finaceList(){
      let data = 'cmd=jiexi_query&domainname='+this.$route.params.name+'&title=';
      this.$http.post('https://api.abeiyun.com/www/domain.php',data).then(({data})=>{
        if(data.response==200){
          this.analyList = [...data.data.content.filter(item => this.$route.params.id === item.id)][0]
          switch (this.analyList.ttl) {
            case '120':
              this.analyList.ttl = '2分钟'
              break
            case '600':
              this.analyList.ttl = '10分钟'
              break
            case '1800':
              this.analyList.ttl = '30分钟'
              break
            case '3600':
              this.analyList.ttl = '1小时'
              break
            case '7200':
              this.analyList.ttl = '2小时'
              break
          }
          this.analyList.ttl = [this.analyList.ttl]
          this.analyList.mx_priority = this.analyList.mx_priority == 0 ? '' : this.analyList.mx_priority
        }
      })
    },
    async submit() {
      let ttl;
      switch (this.analyList.ttl[0]) {
        case '2分钟':
          ttl = '120'
          break
        case '10分钟':
          ttl = '600'
          break
        case '30分钟':
          ttl = '1800'
          break
        case '1小时':
          ttl = '3600'
          break
        case '2小时':
          ttl = '7200'
          break
      }
      let data = 'cmd=jiexi_modify'+
        '&ac_id='+ this.$route.params.id +
        '&mx='+ this.analyList.mx_priority +
        '&content='+ this.analyList.content +
        '&ttl='+ ttl
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/domain.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.finaceList()
            }
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/changeanaly.vue